import { debounce } from "lodash";
import { useMemo, useState } from "react";

export default function useDebounce(
  time: number = 500,
  defaultValue: string = ""
) {
  const [keyword, setKeyword] = useState<string>(defaultValue); // debounced value
  const [inputValue, setInputValue] = useState<string>(defaultValue); // immediate value

  // Memoize debounce so it doesn't reset every render
  const delayedUpdate = useMemo(
    () =>
      debounce((value: string) => {
        setKeyword(value);
      }, time),
    [time]
  );

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setInputValue(newValue); // show immediately in input
    delayedUpdate(newValue); // update keyword after delay
  };

  const handleInputSearch = (value: string) => {
    setInputValue(value);
    delayedUpdate(value);
  };

  const handleEnterValue = (value?: string) => {
    setInputValue(value || "");
    setKeyword(value || "");
  };

  return {
    keyword,
    inputValue,
    handleInputChange,
    handleInputSearch,
    handleEnterValue,
  };
}
